import { greetingName } from '@/lib/greetingName'

type GreetingProps = {
  email: string | null
  /** Best-effort display name from useSession — preferred over email parsing. */
  displayName: string | null
}

/**
 * Resolve the first name used in "Welcome back, <em>{firstName}</em>.".
 * Prefers the first whitespace-separated chunk of a real display name
 * (which might be server-provided); falls back to the email-local-part
 * heuristic when no name is known.
 */
function resolveFirstName(displayName: string | null, email: string | null): string {
  if (displayName) {
    const first = displayName.split(/\s+/).filter(Boolean)[0]
    if (first) return first
  }
  return greetingName(email)
}

/**
 * The anchored heading of the Lobby column. Same h1 + .sub pair every
 * Passport screen uses, so signing in and landing here reads as one flow
 * rather than a handoff to another app.
 */
export function Greeting({ email, displayName }: GreetingProps) {
  const firstName = resolveFirstName(displayName, email)
  return (
    <>
      <h1>
        Welcome back, <em>{firstName}</em>.
      </h1>
      <p className="sub">
        Pick a workspace to continue.
        <span className="dk">
          {' '}
          You&rsquo;re already signed in &mdash; we won&rsquo;t ask again.
        </span>
      </p>
    </>
  )
}
